// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ChartJS from 'chart.js'
import axios from 'axios'
import VueResource from 'vue-resource'
import { store } from './store/store'
import moment from 'moment'
import tz from 'moment-timezone'
import VueProgressBar from 'vue-progressbar'
import Underscore from 'underscore'
import vSelect from 'vue-select'
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'
import VueAnalytics from 'vue-ua'
import VueHead from 'vue-head'

const options = {
  color: '#4671fb',
  failedColor: '#874b4b',
  thickness: '2px',
  transition: {
    speed: '0.5s',
    opacity: '0.6s'
  },
  autoRevert: true,
  location: 'top',
  inverse: false
}

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}
miniToastr.init({types: toastTypes})
function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}
const toastOptions = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}

Vue.use(VueNotifications, toastOptions)
Vue.use(VueProgressBar, options)
Vue.use(axios)
Vue.use(vSelect)
Vue.use(VueHead)
Vue.use(Underscore)
Vue.use(VueAnalytics, {
  appName: 'Worklogs', // Mandatory
  appVersion: '1.0.0', // Mandatory
  trackingId: 'UA-98907449-1', // Mandatory
  vueRouter: router // Pass the router instance to automatically sync with router (optional)
})

axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.slacktoken
axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.data.error === 'token_invalid') {
    localStorage.clear()
    router.push('/')
  }
  else if (error.response.data.error === 'token_expired') {
    localStorage.clear()
    router.push('/')
  }
  return Promise.reject(error)
})

Vue.config.productionTip = false

/* eslint-disable no-new */
var vm = new Vue({
  el: '#app',
  router,
  store: store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js